import _extends from "@babel/runtime/helpers/extends";
import { Box, Divider, LinearProgressBar, Text } from '@wix/design-system';
import React from 'react';
import { getWdsSurfaceTertiaryProps } from '../../../../utils/wds-theme-colors';
export const AltTextOverviewSection = _ref => {
  let {
    totalCount,
    filledCount,
    progressText,
    description,
    actionContent,
    showDivider = true,
    useStudioSurfaces = false
  } = _ref;
  const progressPercent = totalCount > 0 ? filledCount / totalCount * 100 : 0;
  const isComplete = filledCount === totalCount && totalCount > 0;
  const stickyBackgroundProps = useStudioSurfaces ? getWdsSurfaceTertiaryProps() : {
    backgroundColor: 'D80'
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    dataHook: "alt-text-overview-container",
    direction: "vertical",
    position: "sticky",
    top: "0",
    zIndex: "10"
  }, stickyBackgroundProps), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1",
    padding: "SP2 SP6 SP3 SP6"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP2",
    justifyItems: "space-between",
    width: "100%",
    inline: true
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(LinearProgressBar, {
    dataHook: "alt-text-overview-progress-bar",
    padding: "none",
    skin: "success",
    value: progressPercent
  })), /*#__PURE__*/React.createElement(Box, {
    marginLeft: "auto",
    marginTop: "SP1",
    minWidth: "fit-content"
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: "alt-text-overview-progress-text",
    size: "tiny",
    skin: isComplete ? 'success' : 'standard',
    weight: "thin",
    secondary: true
  }, progressText))), /*#__PURE__*/React.createElement(Text, {
    dataHook: "alt-text-overview-description",
    size: "tiny",
    weight: "thin"
  }, description), actionContent), showDivider && /*#__PURE__*/React.createElement(Divider, null));
};
//# sourceMappingURL=alt-text-overview-section.js.map